import React from "react";
import "./Modal.css";

const ArticleDetailModal = ({ subItem, Download, onClose }) => {
  const formatContent = (content) => {
    return content.split("\n").map((paragraph, index) => {
      if (paragraph.trim() === "") {
        return <br key={index} />;
      }
      return (
        <p key={index} style={{ marginBottom: "1rem", textAlign: "right" }}>
          {paragraph}
        </p>
      );
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content article-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>{subItem.title}</h2>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-body">
          <div
            style={{
              whiteSpace: "pre-line",
              lineHeight: "1.6",
              textAlign: "right",
              direction: "rtl",
            }}
            className="article-content"
          >
            <p>
              {subItem.content}
              {/* {formatContent(subItem.content)} */}
            </p>
          </div>
        </div>
        <div className="modal-footer">
          {Download && (
            <a
              style={{
                color: "var(--main-color)",
                cursor: "pointer",
              }}
              href={Download}
              download={`${subItem.title}.pdf`} // اسم الملف عند التحميل
              target="_blank"
              rel="noreferrer"
            >
              لقراءة كامل المقال قم بتحميله من هنا.
            </a>
          )}
          <button className="action-btn" onClick={onClose}>
            إغلاق
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArticleDetailModal;
